export default "__VITE_ASSET__Dn2yBdlD__"